module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "om-radio__list flex wrap sb",
    class: [(("om-radio__list--" + _vm.variant))]
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      class: [_vm.choosedValue === item.value ? 'active' : '', _vm.variantClass],
      attrs: {
        "title": (_vm.variant === 'check' && item.name ? item.name : null)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeAction(item.value)
        }
      }
    }, [(_vm.variant === 'button' && typeof item.name !== 'undefined') ? _c('span', [_vm._v(_vm._s(item.name))]) : (_vm.variant === 'button' && typeof item.value !== 'undefined') ? _c('span', [_vm._v(_vm._s(item.value))]) : _vm._e()])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdf1354c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/radio/Radio.vue
// module id = 285
// module chunks = 1